import React from 'react';
import Counter from '../components/counter';
import Button from '../components/button';

const CounterDisplay = ({darkMode, run, converTime, timer, restTime, start, stop}) => {
    return (
        <div className={"counter-display"}>
            <Counter className="title" name={restTime ? "Time to get some rest" : "Let's focus"}></Counter>
            <Counter className="counter" name={converTime(timer)}></Counter>
                {!run ? 
                ( <Button className="hvr-float" name={"RUN"} onClick={start}></Button> ) :
                (<Button className={darkMode ? "stop-hvr-float" : "stop-hvr-float-light"} name={"STOP"} onClick={stop}></Button>)}
        </div>
    );
}

export default CounterDisplay;
